"use client";

import React from "react";
import { Instagram, Twitter, Facebook, Flame } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="235526" className="space-y-3">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            Accueil
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            Qui-suis-je
          </Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            Contact
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function FooterFornitoreGas() {
  const socials = [{
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  const policies = [{
    label: "SEO Strategy",
    href: "#"
  }, {
    label: "AI Integration",
    href: "#"
  }, {
    label: "Marketing Automation",
    href: "#"
  }, {
    label: "Webmastering",
    href: "#"
  }];
  return <section id="signature-digitale" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs font-default">
              CEO de Smilegeeks. Expert en marketing digital, SEO et IA, 
              dédié à la création d'expériences numériques d'exception.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight uppercase text-foreground">
              Navigation
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight uppercase text-foreground">
              Expertises
            </h3>
            <ul className="space-y-3">
              {policies.map((policy, i) => <li key={i} data-index={i}>
                  <Link to={policy.href} className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
                    {policy.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight uppercase text-foreground">
              Réseaux
            </h3>
            <div className="flex gap-4">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} className="bg-muted hover:bg-primary hover:text-primary-foreground text-muted-foreground p-2.5 rounded-lg transition-all duration-300 shadow-sm hover:shadow-primary/20" aria-label={social.label}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="pt-8 border-t border-border/50 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[10px] text-muted-foreground tracking-widest uppercase font-mono">
            © 2024 HENINTSOA ANDRIANTOMADY - BUILT FOR THE FUTURE
          </p>
          <div className="flex items-center gap-2 text-muted-foreground group cursor-pointer">
            <Flame className="size-4 text-secondary group-hover:animate-pulse" />
            <span className="text-xs font-mono group-hover:text-foreground transition-colors">BACK TO TOP</span>
          </div>
        </div>
      </div>
    </section>;
}